/** @format */

import React, { useState } from "react";
import { Alert, Button, Modal } from "antd";
import Information from "../../assets/img/background-info.svg";

const ModalInformation = () => {
  const [open, setOpen] = useState<any>(
    localStorage.getItem("informationIndikatif") ? false : true,
  );
  const handleClose = () => {
    setOpen(false);
    localStorage.setItem("informationIndikatif", "false");
  };
  return (
    <Modal
      open={open}
      destroyOnClose={true}
      footer={null}
      width={1200}
      onCancel={handleClose}
      wrapClassName="modalBos "
      className="rounded-xl shadow-xl"
      centered
      bodyStyle={{
        backgroundImage: `url(${Information})`,
        backgroundSize: `cover`,
        minHeight: 500,
      }}
      closable={true}>
      <div className=" w-2/3 text-center h-full px-10 my-15 py-10 align-center">
        <div className="text-4xl font-bold mb-2 text-green-700">PENTING</div>
        <Alert
          className="mb-2 text-left"
          description={
            <>
              Perpanjangan{" "}
              <strong>Jadwal Pengajuan BOS Triwulan 2 TA.2025</strong> Sebagai
              berikut :
              <ol className="list-none mt-2">
                <li>
                  1. Pengajuan Dokumen BOS sampai dengan 5 Juli 2025 pukul 17:00
                  WIB
                </li>
                <li>
                  2. Verifikasi Dokumen Pengajuan BOS sampai dengan 6 Juli 2025
                  pukul 17:00 WIB
                </li>
              </ol>
            </>
          }
          type="info"
          showIcon
        />
        {/* <div className="mb-4 text-lg shadow rounded-md  border-4 border-blue-500 p-4">
          <div className="mb-4 text-center bg-blue-500 text-white font-bold">
            Langkah - Langkah Pelaporan APBN BOS Triwulan
          </div>
          <iframe
            className="w-full"
            height={230}
            src="https://www.youtube.com/embed/G_2vVDkWu80?si=_qgF9kaae5tlf_sq"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            // referrerpolicy="strict-origin-when-cross-origin"
            //  allowfullscreen
          ></iframe>
        </div> */}
        <div className="mb-2 text-lg">
          Bagi madrasah yang telah menerima dana{" "}
          <span className="font-bold">BOS 2025</span>, agar input realisasi
          dilakukan secara bulanan serta <span className="font-bold">BKU</span>{" "}
          dan <span className="font-bold">LPJ</span> bulanan dibuat paling
          lambat tanggal 10 bulan berikutnya{" "}
          <p className="font-bold  mt-4 text-sm">
            <span className="text-red-500">(*) </span> Pesan ini terkirim ke
            akun madrasah, kab/kota, provinsi dan auditor!
          </p>
        </div>
        <Button
          size="large"
          className="mt-5"
          type="primary"
          onClick={handleClose}>
          <div className=" mx-10 font-bold text-white">Kembali</div>
        </Button>
      </div>
    </Modal>
  );
};
export default ModalInformation;
